import React from "react";
import { TableHeaderColumn } from "react-bootstrap-table";
import Crud from "../Crud";

function UserProfile() {
  return (
    <Crud
      title="User Profile"
      getUrl={() => "/User/UserProfile_GetList"}
      // INSERT
      insertUrl={() => "/User/UserProfile_Insert"}
      insertParams={({ userId }, { profileName, description }) => ({
        Name: profileName,
        Description: description,
        IdUser: Number(userId),
      })}
      // UPDATE
      updateUrl={() => "/User/UserProfile_Update"}
      updateParams={(
        { userId },
        { idUserProfile, profileName, description }
      ) => ({
        IdUserProfile: idUserProfile,
        Name: profileName,
        Description: description,
        IdUser: Number(userId),
      })}
      // DELETE
      deleteUrl={() => "/User/UserProfile_Delete"}
      deleteParams={({ userId }, id) => ({
        IdUserProfile: id,
        IdUser: Number(userId),
      })}
    >
      <TableHeaderColumn
        visible="none"
        hiddenOnInsert
        autoValue={true}
        hidden
        isKey
        dataField="idUserProfile"
      >
        Id
      </TableHeaderColumn>
      <TableHeaderColumn
        dataField="profileName"
        filter={{ type: "TextFilter", delay: 1000 }}
      >
        Name
      </TableHeaderColumn>
      <TableHeaderColumn
        dataField="description"
        filter={{ type: "TextFilter", delay: 1000 }}
      >
        Description
      </TableHeaderColumn>
      <TableHeaderColumn
        hiddenOnInsert
        autoValue={true}
        filter={{ type: "TextFilter", delay: 1000 }}
        dataFormat={(_, book = {}) => (
          <i
            onClick={() => onSeletedBookChanged(book)}
            className="fa-solid fa-pencil"
          ></i>
        )}
      >
        Rights
      </TableHeaderColumn>
    </Crud>
  );
}

export default UserProfile;
